import React, { useState } from "react";
import SearchDropDownListPaginationComponent from "../casp/common/SearchDropDownPaginationList";
import { getUserList } from "../../api/casp/user";
import { Role } from "../../constants/Role";
import { ChangeRequestModule } from "../../constants/Module";
import { Action } from "../../constants/Common";
import Loader from "../Common/Loader";
import { MemberIcon } from "../../constants/MemberIcon";
import { withTranslation } from "react-i18next";
import UserProfile from "../casp/common/userProfile";

const RemoveResources = (props) => {
  const [refresh, setRefresh] = useState(+new Date());
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div>
      <div className="">
        <div className="row">
          <div className="col-md-12">
            <SearchDropDownListPaginationComponent
              label={props.t("Remove Resources")}
              searchEnabled={false}
              key={refresh}
              listCall={getUserList}
              emitItem={(newValue) => {
                if (newValue) {
                  setIsLoading(true);
                  props.validate(
                    {
                      module: ChangeRequestModule.PROJECT_USER,
                      event: Action.DELETE,
                    },
                    [...props.teamMembers, 
                      { id: newValue.id, label: `${newValue.firstName} ${newValue.lastName}`, profilePicture: newValue.profilePicture},
                    ],
                    () => {
                      setIsLoading(false);
                      setRefresh(+new Date());
                    },
                    () => {
                      setIsLoading(false);
                    }
                  );
                }
              }}
              apiParams={{
                includeAdmins: false,
                filterFields: ["projectUser"],
                filterInputs: [props.project?.id],
                excludeFilterFields: ["id"],
                isActive: true,
                excludeFilterInputs: [
                  props?.teamMembers?.length
                    ? props?.teamMembers?.map((t) => t.id).toString()
                    : [""],
                ],
              }}
            />
            <div className="d-flex mt-2">
              {props?.teamMembers?.length > 0 &&
                !isLoading &&
                props.teamMembers.map((item, index) => (
                  <>
                  <span
                    key={item.id}
                    className="c-pill c-pill--success d-flex changeRequest_badge ms-1"
                    style={{ backgroundColor: "#ffd6cc" }}
                  >
                    <UserProfile user={item} avatarClassName='me-2' profileClassName='me-2' profileStyle ={{height: '30px', width: '30px', fontSize: '15px'}} tooltip={true}/>
                    {item.label}
                    <i
                      className="ri-close-line ms-1"
                      style={{ backgroundColor: "#e62e00", cursor: "pointer" }}
                      onClick={(event) => {
                        event.stopPropagation();
                        props?.removeItemFromPayload(
                          {
                            module: ChangeRequestModule.PROJECT_USER,
                            event: Action.DELETE,
                            item,
                          },
                          index
                        );
                      }}
                    ></i>
                  </span>
                  </>
                ))}
              {isLoading && <Loader />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation() (RemoveResources);
